import $ from 'jquery';

let $businesses	 = $('.c-businesses-grid'),
    $logos			 = $businesses.find('.c-loop-business_logo-wrapper'),
    $titles			 = $businesses.find('.c-loop-business_title');

function archiveBusinesses() {
	if( $businesses.length ) {		
		equalize($logos);
		
		$(window).resize(function() {
			if( Foundation.MediaQuery.atLeast('xlarge') ) {
				equalize($logos);
			}
			else {
				$logos.css('height', 'auto');
			}
		})
	}
}

function equalize($elements) {
	let height = 0;
	
	$elements.each( function( i, $el ) {
		// Reset element height
		$(this).css('height', 'auto');
		
		var elHeight = $( this ).outerHeight()
		
		if ( elHeight > height ) {
			height = elHeight
		}
	})
	
	$elements.css({ 'height': height });
}

export { archiveBusinesses }